import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "pages" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = {
  key: 0,
  class: "page-header"
}
const _hoisted_5 = { class: "page-content" }

import store from "@/store";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import {
  mobileHeader,
  footerMenu,
  mobileMenu,
  fullLoading,
} from "@/common/components";

interface MenuListType {
  icon: string;
  label?: string;
  url?: string;
  key: string;
  active?: boolean;
}

const headerHeight = "4rem";
const titleHeight = "4rem";
const footerHeight = "4rem";


export default /*@__PURE__*/_defineComponent({
  __name: 'menu',
  props: {
    accountId: {},
    tabActive: {},
    menuList: {},
    showHome: { type: Boolean, default: true },
    showBack: { type: Boolean, default: false },
    backUrl: {},
    contentPadding: { default: "1rem" }
  },
  emits: ["open-menu"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v76c08988": (headerHeight),
  "v56f70112": (titleHeight),
  "v26768bca": (footerHeight),
  "v4ab83700": (_ctx.contentPadding)
}))

const { t } = useI18n();

const emit = __emit;

const props = __props;

const mobileMenuOpen = ref<string | null>(null);

const footerMenuList = computed(() => {
  const list: MenuListType[] = [
    {
      key: "menu",
      icon: "grid",
      label: t("common.labels.menu"),
    },
    {
      key: "alert",
      icon: "alert",
      label: t("common.labels.alert"),
    },
  ];

  if (props.showHome && !props.showBack)
    list.unshift({
      key: "home",
      icon: "home-line",
      label: t("common.labels.home"),
      url: `/${props.accountId}/home`,
    });

  if (!props.showHome && props.showBack)
    list.unshift({
      key: "back",
      icon: "arrows-left",
      label: t("common.labels.back"),
      url: props.backUrl,
      active: false,
    });

  return list;
});

function openFooterMenu(value: any) {
  mobileMenuOpen.value = value.key;
  console.log("openFooterMenu", value);
}

function menuMobileClose() {
  mobileMenuOpen.value = null;
}

function openTabMenu(tab: any) {
  emit("open-menu", tab.key);
  menuMobileClose();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(mobileHeader), { height: headerHeight }),
      _createElementVNode("main", _hoisted_3, [
        (_ctx.$slots.title)
          ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
              _renderSlot(_ctx.$slots, "title")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_5, [
          _renderSlot(_ctx.$slots, "content")
        ])
      ]),
      _createVNode(_unref(footerMenu), {
        "menu-list": footerMenuList.value,
        height: footerHeight,
        onOpen: openFooterMenu
      }, null, 8, ["menu-list"])
    ]),
    (_unref(store).getters.loading)
      ? (_openBlock(), _createBlock(_unref(fullLoading), { key: 0 }))
      : _createCommentVNode("", true),
    (mobileMenuOpen.value === 'menu')
      ? (_openBlock(), _createBlock(_unref(mobileMenu), {
          key: 1,
          "menu-list": __props.menuList,
          active: __props.tabActive,
          onOpen: openTabMenu,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (menuMobileClose()))
        }, null, 8, ["menu-list", "active"]))
      : _createCommentVNode("", true)
  ]))
}
}

})